import { clsx } from "clsx";

import { toasterProps } from "~/utils/toast";

export const Alert: React.FC<{
  type?: "error" | "warning" | "info" | "success";
  className?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}> = ({ children, type, className, description }) => {
  const { classNames } = toasterProps.toastOptions;
  return (
    <div
      className={clsx(
        classNames.toast,
        "not-prose text-base shadow-none",
        type ? classNames[type] : classNames.default,
        className,
      )}
    >
      {type && (
        <div className={clsx(classNames.icon, "shrink-0")}>
          {toasterProps.icons[type]}
        </div>
      )}
      <div className={classNames.content}>
        {children}
        {description && (
          <div className={classNames.description}>{description}</div>
        )}
      </div>
    </div>
  );
};
